import React, {Fragment} from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import MUIDataTable from "mui-datatables";
import InfoSummaryTable from '../atoms/summaryTable'

const ResultsTable = ({ data }) => {
	const columns = [
		{
			name: "fecha",
			label: "Fecha-Hora (UTC)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "latitude",
			label: "Lat(°)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "longitude",
			label: "Long(°)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "depth",
			label: "Prof(Km)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "magnitude",
			label: "Mag",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "mag_type",
			label: "Tipo Mag.",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "rms",
			label: "Rms(seg)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "gap",
			label: "Gap(°)",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
			name: "err_latitude",
			label: "Error Lat(Km)",
			options: {
				filter: true,
				sort: true,
			}
		},	
		{
			name: "err_longitude",
			label: "Error Long(Km)",
			options: {
				filter: true,
				sort: true,
			}
		},		
		{
			name: "err_depth",
			label: "Error prof(Km)",
			options: {
				filter: true,
				sort: true,
			}
		},		
		{
			name: "region",
			label: "Región",
			options: {
				filter: true,
				sort: true,
			}
		},		
		{
            name: "sfile",
            options: {
                filter: false,
					customBodyRender: (value, tableMeta, updateValue) => {		
						//console.log("SFILE", tableMeta.rowData[12])		
						return (
							<div>
								<button type="button" rel="tooltip" className="btn btn-info btn-round btn-just-icon btn-sm">
									<a
  										href={`${process.env.REACT_APP_EXCEL_URL}/media/sfiles/${tableMeta.rowData[12]}`}
  										download={tableMeta.rowData[12].split('/').pop()} 
									>
  										<i className="material-icons">arrow_downward</i>
									</a>
								</button>
							</div>
						);
                }
            }
        },
		{
			name: "waveform",
			label: "Forma de Onda",
            options: {
                filter: false,
					customBodyRender: (value, tableMeta, updateValue) => {		
						//console.log("WAVEFORMS", tableMeta.rowData[13])		
						return (
							<div>
								<button type="button" rel="tooltip" className="btn btn-info btn-round btn-just-icon btn-sm">
									<a
  										href={`${process.env.REACT_APP_EXCEL_URL}/media/waveforms/${tableMeta.rowData[13]}`}
  										download={tableMeta.rowData[13].split('/').pop()} 
									>
  										<i className="material-icons">arrow_downward</i>
									</a>
								</button>
							</div>
						);
                }
            }
        },		
		{
			name: "status",
			label: "Estado",
			options: {
				filter: true,
				sort: true,
			}
		},
		{
		  name: "verMapa",
		  label: "VER MAPA",
		  options: {
		    filter: false,
		    sort: false,
		    customBodyRender: (value, tableMeta) => {
		      const lat = tableMeta.rowData[1]; 
		      const lng = tableMeta.rowData[2]; 
		      const mag = tableMeta.rowData[4]; 
		      const region = tableMeta.rowData[11]; 
			
		      const mapaUrl = `/mapa?lat=${lat}&lng=${lng}&mag=${mag}&region=${encodeURIComponent(region)}`;
			
		      return (
		        <div>
		          <button
		            type="button"
		            rel="tooltip"
		            className="btn btn-success btn-round btn-just-icon btn-sm"
		            onClick={() => window.open(mapaUrl, "_blank")}
		          >
		            <i className="material-icons">place</i>
		          </button>
		        </div>
		      );
		    }
		  }
		}
	]


	const options = {
		selectableRows: 'none', 
		responsive: 'standard',
		download: false,
		print: false
	};

	const card = (
		<Fragment>
			<MUIDataTable
				title={""}
				data={data.results}
				columns={columns}
				options={options}
			/>
		</Fragment>
	)
	

  return (
	<Fragment>
		<div className="page-header" id="header" style={{ backgroundImage: "url('assets/img/fallaGeo.jpg')" }} >
			<div className="container">
				<div className="row">
					<div className="col-md-8 ml-auto mr-auto text-center">								
						<h1 className="title">Servicio Geológico Colombiano</h1>
						<h3 className="title">Catálogo TECTO </h3>
						<br /><br />
					</div>
				</div>
			</div>
		</div>	   
		<InfoSummaryTable  data={data}/> <br/>
		<Box sx={{ minWidth: 275 }}>
			<Card variant="outlined">{card}</Card>
		</Box>		
	</Fragment>
	
  );
};

export default ResultsTable;
